import { requestConfig } from "../config.js";

/**
 * Определить местоположения пользователя (город, улица, дом)
 */
export default async function apiFetchUserLocation() {
  const response = await requestConfig.get("/api/v0/autocomplete_address/ip_address/");

  if (!response?.data) throw new Error("Unable to fetch location of user");

  return response.data?.detail;
}
